import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    client: { shortName: "" },
    authUser: {},
    authToken: '',
  },
  mutations: {
    SET_CLIENT(state, data) {
      state.client = data
    },
  },
  actions: {
    getClient({ commit }) {
      axios.get('/client').then(res => {
        window.document.title = res.data.client.shortName + " - Support System";
        commit('SET_CLIENT', res.data.client)
      })
    },
  },
  modules: {
  },
})
